import React, { Dispatch, useState } from 'react';
import S from './duration-input.module.scss';
import { FaSort } from 'react-icons/fa';
import classNames from 'classnames';

interface DurationInputProps {
  isDisabled: boolean,
  id: string,
  name: string,
  value: number,
  label?: string,
  className?: string,
  onChange: Dispatch<{target: {name: string, value: number}}>,
}

const hoursOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
const minutesOptions = [0, 30];

const DurationInput: React.FC <DurationInputProps> = (props) => {
  const { id, className, name, value, label, isDisabled, onChange } = props;

  const [hours, setHours] = useState(Math.floor(value / 3600));
  const [minutes, setMinutes] = useState(Math.floor((value % 3600) / 60));

  const onHoursChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const hrs = parseInt(e.target.value);
    setHours(hrs);
    onChange({target: {name: name, value: hrs * 3600 + minutes * 60}});
  };

  const onMinutesChange = (e : React.ChangeEvent<HTMLSelectElement>) => {
    const mins = parseInt(e.target.value);
    setMinutes(mins);
    onChange({target: {name: name, value: hours * 3600 + mins * 60}});
  };

  return (
    <div id={id} className={`${S.wrapper} ${className}`}>
      {label && (
        <label
          htmlFor={id}
          className={classNames({
            [S.disabled]: isDisabled,
            'w-full': true
          })}
        >
          {label}
        </label>
      )}
      <div className={'flex flex-row items-center'}>
        <div className={`${S.selectWrapper} w-12`}>
          <select
            id={`${id}-hours`}
            name={`${id}-hours`}
            value={hours}
            onChange={onHoursChange}
            disabled={isDisabled}
          >
            {hoursOptions.map((value) => (
              <option key={`${id}-hours_${value}`} value={value}>
                {value}
              </option>
            ))}
          </select>
          <FaSort />
        </div>
        <div className='ml-1'>
          h
        </div>
        <div className={`${S.selectWrapper} w-12 ml-2`}>
          <select
            id={`${id}-minutes`}
            name={`${id}-minutes`}
            value={minutes}
            onChange={onMinutesChange}
            disabled={isDisabled}
          >
            {minutesOptions.map(( value) => (
              <option key={`${id}-minutes_${value}`} value={value}>
                {value}
              </option>
            ))}
          </select>
          <FaSort />
        </div>
        <div className='ml-1'>
          m
        </div>
      </div>
    </div>
  );
};

export default DurationInput;
